import { Component, OnInit } from '@angular/core';
import { IPagination, IDynamicTableColumn } from '../../../../shared/interfaces';
import {
  DialogConfig,
  DialogImportComponent,
} from '../../components/dialog-import/dialog-import.component';
import { MatDialog } from '@angular/material/dialog';
import { LmrServices } from '../../services/lmr.service';
import Utils from '@app/shared/utils/utils';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-defect-solution',
  templateUrl: './defect-solution.component.html',
  styleUrls: ['./defect-solution.component.sass'],
})
export class DefectSolutionComponent implements OnInit {
  // Labels para o header compartilhado
  headerTitle = 'Cadastro de defeito e solução';
  headerSubtitle =
    'Cadastre os defeitos que aparecem nos aparelhos danificados e as soluções aplicadas.';

  // Configuração das Colunas
  tableColumns = [
    { columnDef: 'manufacturer', header: 'Fabricante' },
    { columnDef: 'defect', header: 'Defeito' },
    { columnDef: 'defectType', header: 'Tipo de defeito' },
    { columnDef: 'solution', header: 'Solução' },
  ];

  tableData: any[] = [];
  loaded = false;

  pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  };

  selectedManufacturers: string[] = [];
  searchTerm: string = '';
  filter = {
    'filtro': '',
    'Page': 1,
    'PageSize': 10,
  };
  defects: [] = [];
  constructor(
    private dialog: MatDialog,
    private lmrServices: LmrServices,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadDefects(this.filter);
  }

  loadDefects(filter?: any): void {
    this.lmrServices.listDefectSolution(filter).subscribe({
      next: (response) => {
        const listaDaApi = response?.page ?? [];
        this.defects = response?.page ?? [];
        this.tableData = listaDaApi.map((item: any) => ({
          manufacturer: item?.fabricante ?? '',
          defect: item?.defeito ?? '',
          defectType: item?.tipoDefeitoDescricao ?? '',
          solution: item?.solucao ?? '',
        }));

        this.pagination = {
          currentPage: response?.currentPage ?? 1,
          pageSize: response?.pageSize ?? 10,
          totalItems: response?.count,
        };
        this.loaded = true;
      },

      error: (error) => {
        this.tableData = [];
        this.pagination = {
          currentPage: 1,
          pageSize: 10,
          totalItems: 0,
        };
        this.loaded = true;
        this.toastr.error(error?.errors?.[0] ?? 'Erro ao carregar fornecedores.');
      },
    });
  }

  onSearch(): void {
    const manufacturers = this.selectedManufacturers?.join(',') || '';
    this.filter.filtro = `${this.searchTerm || ''} ${manufacturers}`.trim();
    this.loadDefects(this.filter);
  }

  onSearchChange(_event: KeyboardEvent) {
    if (this.searchTerm === '') {
      this.onSearch();
    }
  }

  openImportDialog() {
    const dialogRef = this.dialog.open(DialogImportComponent, {
      width: '900px',
      maxWidth: '95vw',
      panelClass: 'custom-import-dialog',
      data: {
        defects: this.defects,
        mode: 'simple',
        textDialog:
          'Para importar a tabela, selecione o arquivo base com as informações dos defeitos e soluções, em seguida, clique em “Importar”.',
        importFn: (file: File) => this.lmrServices.importDefectSolution(file),
      } as DialogConfig,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loadDefects();
      }
    });
  }
  downloadTemplate() {
    const fileName = `Modelo_Template_Importacao_Defeito_Solucao`;
    this.lmrServices.exportDefectSolutionTemplate().subscribe({
      next: (data) => {
        Utils.createAndDownloadBlobFile(data, fileName, 'xlsx');
      },
      error: (err) => {
        const { errors } = Utils.arrayBufferToJson(err);
        this.toastr.error(errors || 'Ocorreu um erro ao exportar, tente novamente mais tarde.');
      },
    });
  }

  onPageChange(event: { currentPage: number; pageSize: number }): void {
    this.filter.Page = event.currentPage;
    this.filter.PageSize = event.pageSize;
    this.loadDefects(this.filter);
  }

  onManufacturerChange(event: any) {
    this.selectedManufacturers = event.value;
  }
}
